// Shared CSV helpers. Single source of truth — used by every export call
// site (Invoices.js Period Summary + Single Item History, plus the new
// Top Spend / Top Movers report-type exports in TopReports.js).
//
// Per RFC 4180: any cell containing comma, quote, or newline gets quoted,
// and existing quotes are escaped by doubling.

export function csvCell(v) {
  if (v == null) return '';
  const s = String(v);
  if (/[",\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}
